var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMakeshorter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8084_39372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33333 4.95801C2.17862 4.95801 2.03025 5.01947 1.92085 5.12886C1.81146 5.23826 1.75 5.38663 1.75 5.54134C1.75 5.69605 1.81146 5.84442 1.92085 5.95382C2.03025 6.06322 2.17862 6.12467 2.33333 6.12467H11.375C11.5297 6.12467 11.6781 6.06322 11.7875 5.95382C11.8969 5.84442 11.9583 5.69605 11.9583 5.54134C11.9583 5.38663 11.8969 5.23826 11.7875 5.12886C11.6781 5.01947 11.5297 4.95801 11.375 4.95801H2.33333ZM2.33333 7.87467C2.17862 7.87467 2.03025 7.93613 1.92085 8.04553C1.81146 8.15493 1.75 8.3033 1.75 8.45801C1.75 8.61272 1.81146 8.76109 1.92085 8.87049C2.03025 8.97988 2.17862 9.04134 2.33333 9.04134H7C7.15471 9.04134 7.30308 8.97988 7.41248 8.87049C7.52187 8.76109 7.58333 8.61272 7.58333 8.45801C7.58333 8.3033 7.52187 8.15493 7.41248 8.04553C7.30308 7.93613 7.15471 7.87467 7 7.87467H2.33333Z",
    fill: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8084_39372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeshorter);
export default __webpack_public_path__ + "static/media/make shorter.80a731659acb57b59212dd310cdef82a.svg";
export { ForwardRef as ReactComponent };